module.exports = __webpack_public_path__ + "static/img/HARRY-DE-MATTIA.48bd9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HARRY-DE-MATTIA.jpg
// module id = DO38
// module chunks = 0